export interface CourseBasicInfo {
    _id:                       string;
    name:                      string;
    aclMetaData:               AclMetaData;
    updatedAt:                 Date;
    createdAt:                 Date;
    setting:                   Setting;
    milestones:                Milestone[];
    goals:                     Goal[];
    status:                    string;
    targetYear:                string[];
    expiryDate:                Date;
    startDate:                 Date;
    draftCompletionPercentage: number;
    publishedAt:               Date;
    publishedBy:               PublishedBy;
    price:                     null;
    contributors:              PublishedBy[];
    courseId:                  string;
    syllabus:                  Syllabus;
}

export interface AclMetaData {
    allowedTo: AllowedTo[];
    createdBy: CreatedBy;
}

export interface AllowedTo {
    _id:                  string;
    accessAllowed:        string[];
    allPermissionAllowed: boolean;
    userGroup:            CreatedBy;
    miniLibrary:          CreatedBy;
    user:                 CreatedBy;
}

export interface CreatedBy {
    id: PublishedBy | null;
}

export interface PublishedBy {
    _id?:          string;
    firstName?:    string;
    lastName?:     string;
    roles?:        Role[];
    profileImage?: string;
    id?:           PublishedBy;
}

export interface Role {
    roleId: RoleId;
}

export interface RoleId {
    _id:  string;
    role: string;
}

export interface Goal {
    _id:  string;
    name: string;
}

export interface Milestone {
    objective:         string;
    number:            number;
    tentativeDuration: string;
    name:              string;
    _id:               string;
    milestoneTest:     MilestoneTest[];
    chapters:          Chapter[];
}

export interface Chapter {
    chapterId: string;
    _id:       string;
}

export interface MilestoneTest {
    testId: string;
    _id:    string;
}

export interface Setting {
    tags: Tag[];
}

export interface Tag {
    tagType: string;
    value:   string;
    tagName: string;
    _id:     string;
}

export interface Syllabus {
    class:    Goal[];
    subjects: Subject[];
}

export interface Subject {
    _id:        string;
    subjectIds: string[];
    chapters:   number;
    concepts:   number;
}



export const CourseDetailDefault : any = {
    _id:                       "",
    name:                      "",
    updatedAt:                 "",
    createdAt:                 "",
    setting:                   [],
    milestones:                [],
    goals:                     [],
    status:                    "",
    targetYear:                [],
    expiryDate:                "",
    startDate:                 "",
    draftCompletionPercentage: 0,
    publishedAt:               "",
    publishedBy:               "",
    price:                     0,
    contributors:              [],
    courseId:                  "",
    syllabus:                  [],
    sharedWith:                []
}